import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../constants/query_keys';
import { apiV1 } from '../lib/api';
import { FIVE_MINUTES_IN_MS } from '../lib/time';

export const useWaterbodySummary = (params: { waterbodySlug: string }) => {
  const { waterbodySlug } = params;
  const waterbodySummaryQuery = useQuery({
    queryKey: QueryKeys.WATERBODIES.SUMMARY(waterbodySlug),
    queryFn: async () => {
      const [keyForageRes, seasonalBaitColorsRes, seasonalPatternsRes, seasonalStructureRes] =
        await Promise.allSettled([
          apiV1.waterbodySummariesKeyForageFetch(waterbodySlug, {
            version: 'v1',
            model: 'flavorful-lunker',
          }),
          apiV1.waterbodySummariesSeasonalBaitColorsFetch(waterbodySlug, {
            version: 'v1',
            model: 'flavorful-lunker',
          }),
          apiV1.waterbodySummariesSeasonalPatternsFetch(waterbodySlug, {
            version: 'v2',
            model: 'flavorful-lunker',
          }),
          apiV1.waterbodySummariesSeasonalStructureFetch(waterbodySlug, {
            version: 'v1',
            model: 'flavorful-lunker',
          }),
        ]);

      const key_forage = keyForageRes.status === 'fulfilled' ? keyForageRes.value.data.data : null;
      const seasonal_bait_colors =
        seasonalBaitColorsRes.status === 'fulfilled' ? seasonalBaitColorsRes.value.data.data : null;
      const seasonal_patterns =
        seasonalPatternsRes.status === 'fulfilled' ? seasonalPatternsRes.value.data.data : null;
      const seasonal_structure =
        seasonalStructureRes.status === 'fulfilled' ? seasonalStructureRes.value.data.data : null;

      return {
        key_forage,
        seasonal_bait_colors,
        seasonal_patterns,
        seasonal_structure,
      };
    },
    enabled: waterbodySlug != null,
    staleTime: FIVE_MINUTES_IN_MS,
  });
  const { data: waterbodySummary } = waterbodySummaryQuery;

  return {
    waterbodySummary,
    hasSummary:
      waterbodySummary != null && Object.values(waterbodySummary).some((value) => value != null),
  };
};
